














import { Component, Vue, Watch } from 'vue-property-decorator';
import VueRouter from 'vue-router';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import Tab from '@/components/Tab/Tab.vue';

Vue.use(VueRouter);

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    Tab,
  },
})
export default class MerchantLeadTab extends Vue {
  name?: string | null = '';
  id?: string | null = '';
  secretKey?: string | null = '';
  roles = '';
  tabs = [{
    label: 'Information',
    to: 'information',
  }];

  get type() {
    return this.$route.params.type;
  }

  @Watch('$route')
  onRouteChange() {
    this.name = this.$route.name;
    this.id = this.$route.params.id;
  }

  mounted() {
    this.id = this.$route.params.id;
    this.name = this.$route.name;
    this.roles = JSON.parse(localStorage.getItem('USER') || '{}').user.user_role.role;
    console.log(this.roles);
    if (this.roles !== 'Sales Acquisition') {
      this.tabs.push({
        label: 'Payment Channel',
        to: 'channels',
      });
    }
  }
}
